import React from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { InsuranceRequirement } from '../../../../../constants/entities';
import { isSameDay, tryFormatDate } from '../../../../../utils/dateUtil';
import { createHeaderCell } from '../../../../../utils/tableUtil';

import CurrentStepCell from './cells/CurrentStepCell';
import InsuredCell from './cells/InsuredCell';

const Cell = ({ data, value, column, ...rest }) => (Array.isArray(value)
  ? value.map(v => <Box key={v}>{v}</Box>)
  : <Box>{value}</Box>);

export const getColumnsForResourceType = automation => {
  switch (automation.trigger.resourceType) {
    case InsuranceRequirement:
      return [
        {
          header: createHeaderCell('Insured'),
          cell: InsuredCell,
          justifyContent: 'flex-start',
          id: 'insured',
          accessor: 'insured',
          colSpan: 2,
          disableSortBy: true,
          name: 'test'
        },
        {
          header: createHeaderCell('Policy Number(s)'),
          cell: Cell,
          justifyContent: 'flex-start',
          id: 'policyNumber',
          accessor: r => r.resource.policies.filter(p => isSameDay(p.expiresAt, r.identifierValue)).map(p => p.number),
          colSpan: 2,
          disableSortBy: true,
          name: 'test'
        },
        {
          header: createHeaderCell('Expiration Date'),
          cell: Cell,
          justifyContent: 'flex-start',
          id: 'expiresAt',
          accessor: r => r.identifierValue,
          colSpan: 2,
          disableSortBy: true,
          name: 'test'
        },
        {
          header: createHeaderCell('Last Email Sent'),
          cell: CurrentStepCell,
          id: 'currentStep',
          accessor: r => r,
          colSpan: 1,
          disableSortBy: true,
          name: 'test'
        }
      ];

    default:
      return [];
  }
};

CurrentStepCell.propTypes = {
  value: PropTypes.shape({
    emails: PropTypes.arrayOf(PropTypes.shape({ stepId: PropTypes.number })),
    stepId: PropTypes.number
  })
};
